var map = {
	"./cover1.jpg": "240d",
	"./icons": "088c",
	"./icons/": "088c",
	"./icons/address.svg": "e8fc",
	"./icons/avatar.svg": "f2e9",
	"./icons/close.svg": "8b1b",
	"./icons/edit.svg": "daf0",
	"./icons/email.svg": "43be",
	"./icons/four-dots.svg": "2fed",
	"./icons/index": "088c",
	"./icons/index.js": "088c",
	"./icons/lock.svg": "9619",
	"./icons/logo-dark.svg": "2e13",
	"./icons/logo-white.svg": "49f8",
	"./icons/menu.svg": "d17f",
	"./icons/open-book.svg": "9734",
	"./icons/phone.svg": "c3bb",
	"./icons/save.svg": "9344",
	"./icons/search.svg": "d103",
	"./icons/user.svg": "6aed",
	"./lazy.gif": "a0f1",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./new-books.jpg": "8a5f",
	"./reading.png": "3191",
	"./recomendations.jpg": "a661",
	"./spiderman.png": "9b83",
	"./thumbnail.png": "1753",
	"./top.jpg": "6b4f",
	"./user.jpg": "18d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";